<!-- /Footer New design -->

<footer class="ytb-v2-footer-area">
  <div class="container">
    <div class="ytb-v2-footer-top-title">
      <div class="footer-logo-v2">
        <div class="ytb-v2-footer-logo ytblogoheight">
          <a href="#">
            <img src="assets/images/footer-images/logo.png" alt="" />
          </a>
        </div>

        <div class="ytb-v2-footer-logo stgLogo">
          <a
            (click)="openLinkInNewTabWindow('https://www.stgcs.com')"
            class="cur_pointer"
          >
            <img src="assets/ytb-images/stglogo.png" alt="" />
          </a>
        </div>
      </div>

      <div class="ytb-v2-footer-social">
        <h2>Social Media</h2>

        <ul>
          <li *ngFor="let social of socialNetwork()">
            <a
              [href]="social.webUrl"
              [title]="social.socialNetworkingName"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                class="h-30"
                [src]="social.imagePath"
                [alt]="social.socialNetworkingName"
              />
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div class="row gx-5 gy-5 ytb-v2-footer-main-menu">
      <!-- Authentication -->
      <div class="col-lg-3 col-6">
        <div class="ytb-v2-footer-menus-items">
          <h3>Authentication</h3>

          <ul>
            <li *ngIf="enableLoginBtn()">
              <a
                (click)="loadComponent()"
                class="loginlink cursor"
                alt="Login"
              >
                Login
              </a>
            </li>

            <li>
              <a
                (click)="goToContactUs()"
                class="loginlink cursor"
                alt="Contact US"
              >
                Contact Us
              </a>
            </li>

            <li *ngIf="enableLoginBtn()">
              <a
                (click)="goToRegister()"
                class="loginlink cursor"
                alt="Register"
              >
                Create Account
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- Useful Links -->
      <div class="col-lg-3 col-6">
        <div class="ytb-v2-footer-menus-items">
          <h3>USEFUL LINKS</h3>

          <ul>
            <li>
              <a routerLink="/about-us" [target]="'_blank'">
                About Us
              </a>
            </li>

            <li>
              <a routerLink="/privacy-policy" [target]="'_blank'">
                Privacy Policy
              </a>
            </li>

            <!-- <li>
              <a routerLink="/covid-policy" [target]="'_blank'">Covid Policy</a>
            </li> -->

            <li>
              <a routerLink="/cookiepolicy" [target]="'_blank'">
                Cookie Policy
              </a>
            </li>

            <li>
              <a routerLink="/help" [target]="'_blank'">
                Help
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- Services -->
      <div class="col-lg-3 col-6">
        <div class="ytb-v2-footer-menus-items">
          <h3>Services</h3>

          <ul>
            <li>
              <a routerLink="/terms-and-conditions" [target]="'_blank'">
                Terms &amp; Conditions
              </a>
            </li>

            <li>
              <a routerLink="/cancellation" [target]="'_blank'">
                Cancellation Policy
              </a>
            </li>

            <li>
              <a routerLink="/refund-policy" [target]="'_blank'">
                Refund Policy
              </a>
            </li>

            <li>
              <a routerLink="/feedback" [target]="'_blank'">
                Feedback
              </a>
            </li>

            <li>
              <a routerLink="/coupons" [target]="'_blank'">
                Coupons
              </a>
            </li>

            <li>
              <a routerLink="/our-services" [target]="'_blank'">
                Our Services
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- Payment & Secure -->
      <div class="col-lg-3 col-6">
        <div class="ytb-v2-footer-menus-items ytb-v2-footer-logos">
          <h3>Payment &amp; Secure</h3>

          <ul>
            <li (click)="openNewTab()" class="cur_pointer">
              <img
                src="assets/images/footer-images/northern-security.png"
                alt=""
              />
            </li>

            <li (click)="openNewTab()" class="cur_pointer">
              <img
                src="assets/images/footer-images/DigiCert-logo.png"
                alt=""
              />
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Copyright -->
    <div class="ytb-v2-footer-copywright copy-write">
      <p>
        All Rights Reserved. © 2016 - 2024 Copyright YourTravelBooking.com,
        owned and operated by YourRentalCar LLC is located in Jacksonville,
        Florida. We are proud to be in collaboration with our partners and
        affiliates who share our commitment to delivering travel experiences.
        Our associates contribute to the diversity and excellence of our
        offerings. Florida: #ST40951
      </p>

      <p>
        Your Tavel Booking.com is partnered with and developed by
        <span class="stgLogoBackGroud">
          Software Technology Guidance Corp.
        </span>
        STG Corp is an IT Consulting Firm with experience in designing and
        delivering IT solutions. Here is additional information on it:
        <span
          (click)="openLinkInNewTabWindow('https://www.stgcs.com')"
          class="stgLogoBackGroud"
        >
          www.stgcs.com
        </span>
      </p>

      <div class="ytb-v2-our-partner">
        <img
          src="assets/images/footer-images/method/method-1.png"
          alt="Photo"
        />
        <img
          src="assets/images/footer-images/method/method-2.png"
          alt="Photo"
        />
        <img
          src="assets/images/footer-images/method/method-3.png"
          alt="Photo"
        />
        <img
          src="assets/images/footer-images/method/method-4.png"
          alt="Photo"
        />
        <img
          src="assets/images/footer-images/method/method-5.png"
          alt="Photo"
        />
        <img
          src="assets/images/footer-images/method/method-6.png"
          alt="Photo"
        />
        <img
          src="assets/images/footer-images/method/method-7.png"
          alt="Photo"
        />
        <img
          src="assets/images/footer-images/method/method-8.png"
          alt="Photo"
        />
        <img
          src="assets/images/footer-images/method/method-10.png"
          alt="Photo"
        />
        <img
          src="assets/images/footer-images/method/method-11.png"
          alt="Photo"
        />
        <img
          src="assets/images/footer-images/method/method-12.png"
          alt="Photo"
        />
        <img
          src="assets/images/footer-images/method/method-13.png"
          alt="Photo"
        />
        <img
          src="assets/images/footer-images/method/method-14.png"
          alt="Photo"
        />
        <img
          src="assets/images/footer-images/method/method-15.png"
          alt="Photo"
        />
        <img
          src="assets/images/footer-images/method/method-16.png"
          alt="Photo"
        />
      </div>

      <h2>Prime Service Offerings and Incredible Journeys</h2>
    </div>

    <div class="ytb-v2-footer-copywright">
      <div class="ytb-v2-footer-bottom">
        <div class="row">
          <div class="col-xl-2 col-lg-6 col-sm-6">
            <div
              class="ytb-v2-footer-bottom-items footer-bottom-last-item cur_pointer"
              (click)="openLinkInNewTab('https://www.bbb.org/us/fl/jacksonville/profile/travel-agency/your-travel-booking-0403-235973612/#sealclick')"
            >
              <img
                src="assets/images/footer-images/footer-icons-1.png"
                alt="Photo"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>

<!-- start Footer Wrapper -->

<a
  class="live-chat"
  onclick="javascript:void(Tawk_API.toggle())"
>
  <img
    loading="lazy"
    src="assets/images/liv-chat-icn2.png"
    alt="live-chat"
    title="live-chat"
    width="32"
    height="100"
  />
</a>

<!-- Side Modal Bottom Right Danger-->
<!-- <div
  class="liv-cht-box fade"
  id="sideModalBRDangerDemo"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  data-backdrop="false"
  aria-hidden="true"
>
  <div class="modal-bottom-right" role="document">
    <div class="modal-content liv-chat-icn-cnt">
      <div class="modal-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true" class="white-text">×</span>
        </button>
        <div class="text-center">
          <p>How can we help?</p>
          <small>We will be with you shortly.</small>
        </div>
      </div>

      <div class="modal-body">
        <form class="contact1-form validate-form">
          <span class="contact1-form-title">
            <img
              loading="lazy"
              src="assets/images/footer-images/logo-white.png"
              alt="logo"
              title="logo"
              width="130"
            /><br />
            <span class="font13">Send a message </span>
          </span>

          <div class="wrap-input1" data-validate="Name is required">
            <input class="input1" type="text" name="name" placeholder="Name" />
            <span class="shadow-input1"></span>
          </div>

          <div
            class="wrap-input1"
            data-validate="Valid email is required: ex@abc.xyz"
          >
            <input
              class="input1"
              type="text"
              name="email"
              placeholder="Email"
            />
            <span class="shadow-input1"></span>
          </div>

          <div class="wrap-input1" data-validate="Subject is required">
            <input
              class="input1"
              type="text"
              name="subject"
              placeholder="Subject"
            />
            <span class="shadow-input1"></span>
          </div>

          <div class="wrap-input1" data-validate="Message is required">
            <textarea
              class="input1"
              name="message"
              placeholder="Message"
            ></textarea>
            <span class="shadow-input1"></span>
          </div>

          <div class="container-contact1-form-btn">
            <button class="contact1-form-btn">
              <span> Send a message </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div> -->

<!-- start Back To Top -->

<a
  id="back-to-top"
  href="#"
  class="back-to-top"
  role="button"
  title="Click to return to top"
  data-toggle="tooltip"
  data-placement="left"
>
  <i class="bx bx-chevron-up"></i>
</a>

<!-- end Back To Top -->

<ng-template #load></ng-template>
<ng-template #loadSignup></ng-template>
